module.exports = __webpack_public_path__ + "static/media/confirm-checkbox-checked.8d15f474.svg";